module.exports = __webpack_public_path__ + "media/img/frontend_application/bank-placeholder-114bca845abc6921bbeae74961b982c8.svg";